// extracted by mini-css-extract-plugin
export default {"latestPosts":"LatestPostList_latestPosts__qvBTE"};